/**
 * Определяет, находится ли заданная часть элемента в области видимости.
 *
 * @param {HTMLElement} element - Элемент, который необходимо проверить.
 * @param {number} [visiblePart] - Часть элемента, которая должна находиться во viewport (0 < visiblePart <= 1).
 * @returns {boolean|null} - null возвращается в случае попытки вызова вне браузера или если передан не HTMLElement.
 */

export function isInViewport(element, visiblePart) {
  if (!window) return null;
  if (!(element instanceof HTMLElement)) {
    console.warn('[isInViewport util] Given element is not HTMLElement. Returning NULL.');
    return null;
  }

  let multiplyer = 1 - +visiblePart;
  if (!multiplyer || multiplyer <= 0 || multiplyer > 1) multiplyer = 1;

  const rect = element.getBoundingClientRect();
  const minVisibleHeight = element.offsetHeight * multiplyer;
  const minVisibleWidth = element.offsetWidth * multiplyer;
  const elementVisibilityHorizontal = (rect.left + minVisibleWidth) > 0
    && (rect.right - minVisibleWidth) <= (window.innerWidth || document.documentElement.clientWidth);
  const elementVisibility = (rect.top + minVisibleHeight) > 0
    && (rect.bottom - minVisibleHeight) <= (window.innerHeight || document.documentElement.clientHeight);
  return elementVisibilityHorizontal && elementVisibility;
}

/**
 * Функция, проскролливающая до элемента, если область видимости меньше передаваемой
 *
 * @param {HTMLElement} element - Элемент, до которого необходимо проскроллить.
 * @param {number} [visiblePart] - Часть элемента, которая должна находиться во viewport (0 < visiblePart <= 1).
 */

export const scrollToElement = (element, visiblePart) => {
  const {
    top,
    bottom,
  } = element.getBoundingClientRect();

  const clientHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  if (top > clientHeight * (1 - visiblePart) || bottom < clientHeight * visiblePart) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

/**
 * Возвращает правильный link тэг(canonical или amphtml) для разводных страниц
 *
 * @param {boolean} amp - флаг указывающий amp это страница или нет.
 * @param {string} host - хост сайта
 * @param {object} location - объект location который получается через обертку роутера
 * @returns {HTMLElement} - link тег.
 */
export function getRelLinkTag(amp, host, location) {
  if (amp) {
    return <link rel='canonical' href={`https://${host}${location.pathname.replace(/\/amp/, '')}`} />;
  }
  return <link rel='amphtml' href={`https://${host}/amp${location.pathname}`} />;
}

export function updateBodyAttributes(params) {
  if (!document) return;

  // Этот атрибут используется в компоненте Layout для скрытия всех элементов под фуллскрин-галерею
  const fullscreenAttributeIndicator = 'lbFullscreen';
  const { toFullscreen } = params || {};

  document.body.style.overflow = toFullscreen ? 'hidden' : '';
  if (toFullscreen) {
    document.body.dataset[fullscreenAttributeIndicator] = true;
  } else {
    delete document.body.dataset[fullscreenAttributeIndicator];
  }
}
